import React from 'react';
import ArtGrid from './ArtGrid/ArtGrid';
import './App.css';

const App: React.FC = () => {
  return (
    <div className='app'>
      <ArtGrid />
    </div>
  );
};

export default App;
